<section class="esn-faq-finder">
  @if (heading() || description()) {
    <div class="esn-faq-finder__heading">
      @if (heading()) {
        <h2 class="esn-faq-finder__title">{{ heading() }}</h2>
      }
      @if (description()) {
        <p class="esn-faq-finder__description">{{ description() }}</p>
      }
    </div>
  }
  <esn-search-field [fullWidth]="true" [placeholder]="placeholder()" [(value)]="query" (search)="search.emit($event)" />
  @if (showCount()) {
    <p class="esn-faq-finder__count" role="status">{{ countLabel() }}</p>
  }
  <ng-content />
</section>
